var _filter, _clipPath, _image, _clipPath2, _g, _use, _use2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSerene(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    gradientUnits: "userSpaceOnUse",
    cx: 431.55,
    cy: 547.64,
    fx: 431.55,
    fy: 547.64,
    r: 274.21,
    gradientTransform: "matrix(0.159239,0,0,0.158429,0.00169902,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(30.196078%,30.196078%,30.196078%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(40%,40%,40%)",
      stopOpacity: 0
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 72,
    height: 71,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial1",
    gradientUnits: "userSpaceOnUse",
    cx: 13.3,
    cy: -37.68,
    fx: 13.3,
    fy: -37.68,
    r: 350.59,
    gradientTransform: "matrix(0.159239,0,0,0.158429,0.00169902,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(90.196078%,90.196078%,90.196078%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(90.196078%,90.196078%,90.196078%)",
      stopOpacity: 0
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 72,
    height: 71
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface6",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial1)"
    },
    d: "M 72 35.5 C 72 15.898438 55.882812 0.0078125 36 0.0078125 C 16.117188 0.0078125 0 15.898438 0 35.5 C 0 55.105469 16.117188 70.996094 36 70.996094 C 55.882812 70.996094 72 55.105469 72 35.5 Z M 72 35.5 "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial2",
    gradientUnits: "userSpaceOnUse",
    cx: 8812.97,
    cy: 5710.37,
    fx: 8812.97,
    fy: 5710.37,
    r: 90.11,
    gradientTransform: "matrix(-0.159239,0.000000000000000019,-0.00000000000000002,-0.158429,1416.992216,940.980118)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(94.901961%,94.901961%,94.901961%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(94.901961%,94.901961%,94.901961%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial3",
    gradientUnits: "userSpaceOnUse",
    cx: 83.47,
    cy: 228.8,
    fx: 83.47,
    fy: 228.8,
    r: 85.06,
    gradientTransform: "matrix(0.159239,0,0,0.158429,0.00169902,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(94.901961%,94.901961%,94.901961%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(94.901961%,94.901961%,94.901961%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 219.77,
    y1: 354.9,
    x2: 264.08,
    y2: 283.69,
    gradientTransform: "matrix(0.159239,0,0,0.158429,0.00169902,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(21.176471%,19.607843%,25.098039%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(36.078431%,9.019608%,89.803922%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial4",
    gradientUnits: "userSpaceOnUse",
    cx: 328.35,
    cy: 85.19,
    fx: 328.35,
    fy: 85.19,
    r: 65.24,
    gradientTransform: "matrix(0.159239,0,0,0.158429,0.00169902,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(94.901961%,94.901961%,94.901961%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(94.901961%,94.901961%,94.901961%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial5",
    gradientUnits: "userSpaceOnUse",
    cx: 134.9,
    cy: 258.47,
    fx: 134.9,
    fy: 258.47,
    r: 74.66,
    gradientTransform: "matrix(0.159239,0,0,0.158429,0.00169902,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(94.901961%,94.901961%,94.901961%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(94.901961%,94.901961%,94.901961%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 72,
    height: 71,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.160784,
      stroke: "none"
    }
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image9",
    width: 280,
    height: 231,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARgAAADnCAYAAADFPUn0AAAABmJLR0QA/wD/AP+gvaeTAAABEklEQVR4nO3BAQ0AAADCoPdPbQ43oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAMwPztAABqn6/sAAAAABJRU5ErkJggg=="
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 72,
    height: 71
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface10",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image9",
    transform: "matrix(0.159239,0,0,0.158429,10.242341,33.227335)"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial6",
    gradientUnits: "userSpaceOnUse",
    cx: 334.68,
    cy: 184.89,
    fx: 334.68,
    fy: 184.89,
    r: 112.76,
    gradientTransform: "matrix(0.159239,0,0,0.158429,0.00169902,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(94.901961%,94.901961%,94.901961%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(94.901961%,94.901961%,94.901961%)",
      stopOpacity: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.431373%,18.431373%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 72 35.5 C 72 15.898438 55.882812 0.0078125 36 0.0078125 C 16.117188 0.0078125 0 15.898438 0 35.5 C 0 55.105469 16.117188 70.996094 36 70.996094 C 55.882812 70.996094 72 55.105469 72 35.5 Z M 72 35.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial0)"
    },
    d: "M 72 35.5 C 72 15.898438 55.882812 0.0078125 36 0.0078125 C 16.117188 0.0078125 0 15.898438 0 35.5 C 0 55.105469 16.117188 70.996094 36 70.996094 C 55.882812 70.996094 72 55.105469 72 35.5 Z M 72 35.5 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface6",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,84.313725%,39.607843%)",
      fillOpacity: 1
    },
    d: "M 44.746094 33.851562 L 34.398438 33.851562 L 40.996094 40.445312 C 43.757812 43.242188 43.820312 47.703125 41.144531 50.578125 C 38.46875 53.457031 33.996094 53.738281 30.976562 51.21875 L 34.246094 54.476562 L 44.90625 54.5 C 47.683594 54.5 50.339844 53.394531 52.292969 51.429688 C 54.242188 49.464844 55.316406 46.804688 55.28125 44.042969 C 55.203125 38.363281 50.453125 33.851562 44.746094 33.851562 Z M 44.746094 33.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,84.313725%,39.607843%)",
      fillOpacity: 1
    },
    d: "M 44.746094 33.851562 L 34.398438 33.851562 L 40.996094 40.445312 C 43.757812 43.242188 43.820312 47.703125 41.144531 50.578125 C 38.46875 53.457031 33.996094 53.738281 30.976562 51.21875 L 34.246094 54.476562 L 44.90625 54.5 C 47.683594 54.5 50.339844 53.394531 52.292969 51.429688 C 54.242188 49.464844 55.316406 46.804688 55.28125 44.042969 C 55.203125 38.363281 50.453125 33.851562 44.746094 33.851562 Z M 44.746094 33.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.509804%,94.509804%,94.509804%)",
      fillOpacity: 1
    },
    d: "M 26.914062 36.609375 L 37.261719 36.609375 L 30.664062 30.015625 C 27.910156 27.214844 27.851562 22.761719 30.523438 19.886719 C 33.195312 17.011719 37.664062 16.730469 40.683594 19.242188 L 37.414062 15.980469 L 26.753906 15.960938 C 23.980469 15.960938 21.320312 17.066406 19.371094 19.03125 C 17.421875 20.996094 16.34375 23.65625 16.378906 26.417969 C 16.457031 32.09375 21.210938 36.609375 26.914062 36.609375 Z M 26.914062 36.609375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.509804%,94.509804%,94.509804%)",
      fillOpacity: 1
    },
    d: "M 26.914062 36.609375 L 37.261719 36.609375 L 30.664062 30.015625 C 27.910156 27.214844 27.851562 22.761719 30.523438 19.886719 C 33.195312 17.011719 37.664062 16.730469 40.683594 19.242188 L 37.414062 15.980469 L 26.753906 15.960938 C 23.980469 15.960938 21.320312 17.066406 19.371094 19.03125 C 17.421875 20.996094 16.34375 23.65625 16.378906 26.417969 C 16.457031 32.09375 21.210938 36.609375 26.914062 36.609375 Z M 26.914062 36.609375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial2)"
    },
    d: "M 26.914062 36.609375 L 37.261719 36.609375 L 30.664062 30.015625 C 27.910156 27.214844 27.851562 22.761719 30.523438 19.886719 C 33.195312 17.011719 37.664062 16.730469 40.683594 19.242188 L 37.414062 15.980469 L 26.753906 15.960938 C 23.980469 15.960938 21.320312 17.066406 19.371094 19.03125 C 17.421875 20.996094 16.34375 23.65625 16.378906 26.417969 C 16.457031 32.09375 21.210938 36.609375 26.914062 36.609375 Z M 26.914062 36.609375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial3)"
    },
    d: "M 26.914062 36.609375 L 37.261719 36.609375 L 30.664062 30.015625 C 27.910156 27.214844 27.851562 22.761719 30.523438 19.886719 C 33.195312 17.011719 37.664062 16.730469 40.683594 19.242188 L 37.414062 15.980469 L 26.753906 15.960938 C 23.980469 15.960938 21.320312 17.066406 19.371094 19.03125 C 17.421875 20.996094 16.34375 23.65625 16.378906 26.417969 C 16.457031 32.09375 21.210938 36.609375 26.914062 36.609375 Z M 26.914062 36.609375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 44.746094 33.851562 L 34.398438 33.851562 L 40.996094 40.445312 C 43.757812 43.242188 43.820312 47.703125 41.144531 50.578125 C 38.46875 53.457031 33.996094 53.738281 30.976562 51.21875 L 34.246094 54.476562 L 44.90625 54.5 C 47.683594 54.5 50.339844 53.394531 52.292969 51.429688 C 54.242188 49.464844 55.316406 46.804688 55.28125 44.042969 C 55.203125 38.363281 50.453125 33.851562 44.746094 33.851562 Z M 44.746094 33.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.509804%,94.509804%,94.509804%)",
      fillOpacity: 1
    },
    d: "M 38.058594 19.609375 L 41.976562 23.550781 L 45.796875 27.363281 C 49.335938 30.339844 54.9375 27.878906 54.9375 23.105469 C 54.9375 19.167969 51.730469 15.976562 47.773438 15.976562 L 34.363281 15.960938 L 37.632812 19.222656 C 37.773438 19.347656 37.914062 19.472656 38.058594 19.609375 Z M 38.058594 19.609375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial4)"
    },
    d: "M 38.058594 19.609375 L 41.976562 23.550781 L 45.796875 27.363281 C 49.335938 30.339844 54.9375 27.878906 54.9375 23.105469 C 54.9375 19.167969 51.730469 15.976562 47.773438 15.976562 L 34.363281 15.960938 L 37.632812 19.222656 C 37.773438 19.347656 37.914062 19.472656 38.058594 19.609375 Z M 38.058594 19.609375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.509804%,94.509804%,94.509804%)",
      fillOpacity: 1
    },
    d: "M 38.058594 19.609375 L 41.976562 23.550781 L 45.796875 27.363281 C 49.335938 30.339844 54.9375 27.878906 54.9375 23.105469 C 54.9375 19.167969 51.730469 15.976562 47.773438 15.976562 L 34.363281 15.960938 L 37.632812 19.222656 C 37.773438 19.347656 37.914062 19.472656 38.058594 19.609375 Z M 38.058594 19.609375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,80.784314%,0%)",
      fillOpacity: 1
    },
    d: "M 33.261719 50.835938 L 29.347656 46.894531 L 25.527344 43.078125 C 21.984375 40.101562 16.386719 42.566406 16.386719 47.339844 C 16.386719 51.277344 19.59375 54.46875 23.550781 54.46875 L 36.960938 54.484375 L 33.691406 51.222656 C 33.542969 51.101562 33.402344 50.972656 33.261719 50.835938 Z M 33.261719 50.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial5)"
    },
    d: "M 33.261719 50.835938 L 29.347656 46.894531 L 25.527344 43.078125 C 21.984375 40.101562 16.386719 42.566406 16.386719 47.339844 C 16.386719 51.277344 19.59375 54.46875 23.550781 54.46875 L 36.960938 54.484375 L 33.691406 51.222656 C 33.542969 51.101562 33.402344 50.972656 33.261719 50.835938 Z M 33.261719 50.835938 "
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface10",
    mask: "url(#mask1)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial6)"
    },
    d: "M 44.746094 33.859375 L 34.398438 33.859375 L 40.996094 40.453125 C 43.757812 43.25 43.820312 47.710938 41.144531 50.589844 C 38.46875 53.464844 33.996094 53.746094 30.976562 51.226562 L 34.25 54.5 L 44.90625 54.5 C 47.683594 54.5 50.34375 53.394531 52.292969 51.429688 C 54.242188 49.464844 55.320312 46.804688 55.28125 44.042969 C 55.203125 38.375 50.453125 33.859375 44.746094 33.859375 Z M 44.746094 33.859375 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerene);
export default __webpack_public_path__ + "static/media/serene.66ef22b78609ed3753e1658f55442d02.svg";
export { ForwardRef as ReactComponent };